// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1Q63P"};